import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { removeUserCardDetails } from "../../actions/card_Details_action";
import { userLogout } from "../../actions/user_actions";
import { GrubToastMessage } from "../../components/index";
import * as Constants from "../../constants/Constants";
const GrubErrorHook = (props) => {
    const { addToast } = GrubToastMessage();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const error = (data, suppressToast = false) => {
        let shouldOpenAuthModal = false;
        if (
            undefined !== data?.actionData?.code &&
            null !== data?.actionData?.code &&
            "ERR_NETWORK" == data?.actionData?.code
        ) {
            if (!suppressToast) {
                addToast({
                    isBottomToast: true,
                    alertStatus: Constants.TOAST_TYPE_WARNING,
                    alertTitle: Constants.TOAST_HEADING_SYSTEM_ERROR,
                    alertDescription: Constants.SERVER_IS_NOT_REACHABLE,
                });
            }
        } 
        else if (
            undefined !== data.actionData &&
            null !== data?.actionData &&
            typeof data?.actionData === "object"
        ) {
            let error = data?.actionData?.response?.data;
            if (error?.code === Constants.REQUEST_DENIED_CODE) {
                if (!suppressToast) {
                    addToast({
                        isBottomToast: true,
                        alertStatus: Constants.TOAST_TYPE_WARNING,
                        alertTitle: Constants.TOKEN_EXPIRTED,
                        alertDescription: error.message,
                    });
                }
                localStorage.removeItem("token");
                dispatch(removeUserCardDetails());
                dispatch(userLogout());
                shouldOpenAuthModal = true;
            } else if (error?.code === Constants.UNAUTHORIZE_CODE) {
                if (error.data.tokenExpired) {
                    if (!suppressToast) {
                        addToast({
                            isBottomToast: true,
                            alertStatus: Constants.TOAST_TYPE_WARNING,
                            alertTitle: Constants.TOKEN_EXPIRTED,
                            alertDescription: error.message,
                        });
                    }
                    localStorage.removeItem("token");
                    dispatch(removeUserCardDetails());
                    dispatch(userLogout());
                    shouldOpenAuthModal = true;
                } else {
                    if (!suppressToast) {
                        addToast({
                            isBottomToast: true,
                            alertStatus: Constants.TOAST_TYPE_WARNING,
                            alertTitle: Constants.TOKEN_EXPIRTED,
                            alertDescription: error.message,
                        });
                    }
                    localStorage.removeItem("token");
                    dispatch(removeUserCardDetails());
                    dispatch(userLogout());
                    shouldOpenAuthModal = true;
                }
            } else if (error?.code === Constants.FORBIDDEN_ERROR) {
                if (
                    location.pathname == Constants.SIGNIN_PATH ||
                    location.pathname == Constants.LOGIN_PATH
                ) {
                    if (!suppressToast) {
                        addToast({
                            isBottomToast: true,
                            alertStatus: Constants.TOAST_TYPE_WARNING,
                            alertTitle: Constants.TOAST_TYPE_WARNING,
                            alertDescription: error.message,
                        });
                    }
                } else {
                    navigate(Constants.FORBIDDEN_ERROR_PAGE);
                }
            } else if (
                error?.code ==
                Constants.NOT_FOUND_ERROR
            ) {
                if (!suppressToast) {
                    addToast({
                        isBottomToast: true,
                        alertStatus: Constants.TOAST_TYPE_WARNING,
                        alertTitle: Constants.TOAST_HEADING_WARNING,
                        alertDescription:
                            error?.message,
                    });
                }
                navigate(Constants.NOT_FOUND_ERROR_PAGE);
            } else if (error?.validationCheck) {
                if (!suppressToast) {
                    addToast({
                        isBottomToast: true,
                        alertStatus: Constants.TOAST_TYPE_WARNING,
                        alertTitle: Constants.FIELD_IS_REQUIRED,
                        alertDescription: error.message,
                    });
                }
            } else {
                if (
                    error?.error?.code ==
                    Constants.NOT_FOUND_ERROR
                ) {
                    if (!suppressToast) {
                        addToast({
                            isBottomToast: true,
                            alertStatus: Constants.TOAST_TYPE_WARNING,
                            alertTitle: Constants.TOAST_HEADING_WARNING,
                            alertDescription:
                                error?.error?.message,
                        });
                    }
                    navigate(Constants.NOT_FOUND_ERROR_PAGE);
                } else {
                    if (!suppressToast) {
                        addToast({
                            isBottomToast: true,
                            alertStatus: Constants.TOAST_TYPE_WARNING,
                            alertTitle: Constants.TOAST_HEADING_WARNING,
                            alertDescription: error.message,
                        });
                    }
                }
            }
        }
        return { shouldOpenAuthModal };
    };
    return { error };
};

export default GrubErrorHook;
